export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar exportación"])},
          "go-back-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a gestionar exportación"])},
          "not_available_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se encontraron contenedores para exportar"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])}
        }
      }
    }
  })
}